import {Props} from './model';
import {useStyles} from '../../hooks/styles';
import {ResponsiveView} from '../responsiveView';
import {DeviceSize, useDeviceSize} from '../../theme/helpers';
import {ImageStyle, Platform, View} from 'react-native';
import {images} from '../../../assets/icons';
import React from 'react';
import {useTheme} from '../../theme';
import {hexToRgbA} from '../../pipes/color';

export default ({
  children,
  icon,
  hideImage = false,
  backgroundStyle = {},
  iconStyle,
  contentStyle,
  containerStyle,
}: Props) => {
  const {color} = useTheme();
  const ds = useDeviceSize();
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContent: {
      position: 'relative',
      zIndex: 1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          maxWidth: '60%',
          width: 760,
          minHeight: 576,
        },
        {
          maxWidth: '100%',
          width: '100%',
        },
      ),
    },
    sectionContainer: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    sectionContainerBg: {
      position: 'absolute',
      zIndex: -1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          top: -15,
          width: 560,
          height: 576,
          right: 5,
        },
        {
          width: 234,
          height: 377,
          right: -24,
          bottom: 0,
        },
      ),
    },
    sectionContainerBgImage: {
      marginLeft: 'auto',
      marginBottom: 'auto',
      alignSelf: 'flex-start',
      color: theme.color.shaddowBg,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          resizeMode: 'center',
          width: 560,
          height: 576,
        },
        {
          width: 234,
          height: 377,
          resizeMode: 'contain',
        },
      ),
    } as ImageStyle,
    sectionIcon: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingRight: 35,
      position: 'relative',
      zIndex: 0,
    },
  }));
  const Pattern = ds === DeviceSize.desktop ? images.ServiceDetailsPattern : images.ServiceDetailsPatternMobile;
  return (
    <View style={[styles.sectionContainer, containerStyle]}>
      <View style={[styles.sectionContent, contentStyle]}>{children}</View>
      <ResponsiveView only={[DeviceSize.desktop]}>
        <View style={[styles.sectionIcon, iconStyle]}>{icon}</View>
      </ResponsiveView>
      {!hideImage ? (
        <View style={[styles.sectionContainerBg, backgroundStyle]}>
          <Pattern
            {...styles.sectionContainerBgImage}
            color={Platform.OS === 'web' ? hexToRgbA(color.shaddowBg, 0.15) : color.patternBgColor}
            width={styles.sectionContainerBgImage.width as number}
            height={styles.sectionContainerBgImage.height as number}
            hideForVisuallyImpaired
          />
        </View>
      ) : null}
    </View>
  );
};
